import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/maiscontrole-cronogramas/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/maiscontrole-cronogramas/delete`,
        endpoint: `${endpointBackend}gci/maiscontrole-cronogramas/getall`
    }

    let list = {
        labelTitle: 'Mais Controle - Cronogramas',
        fieldsShowOnDelete: ['descricao'],
        canAdd: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'nome_obra',
                label: 'Obra',
                width: '30%'
            },
            {
                name: 'indice',
                label: 'Índice'
            },
            {
                name: 'etapa_item',
                label: 'Etapa/Item'
            },
            {
                name: 'descricao',
                label: 'Descrição',
                width: '30%'
            },
            {
                name: 'dias_uteis_desconsiderar',
                label: 'Dias Úteis Desconsiderar'
            },
            {
                name: 'dias_uteis_planejado',
                label: 'Dias Úteis Planejado'
            },
            {
                name: 'dias_corridos_planejado',
                label: 'Dias Corridos Planejado'
            },
            {
                name: 'data_inicio_planejado',
                label: 'Data Início Planejado'
            },
            {
                name: 'data_fim_planejado',
                label: 'Data Fim Planejado'
            },
            {
                name: 'dias_uteis_realizado',
                label: 'Dias Úteis Realizado'
            },
            {
                name: 'dias_corridos_realizado',
                label: 'Dias Corridos Realizado'
            },
            {
                name: 'data_inicio_realizado',
                label: 'Data Início Realizado'
            },
            {
                name: 'data_fim_realizado',
                label: 'Data Fim Realizado'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={list.canAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
